import gql from "graphql-tag";

export const REPOPULATE_ASSOCIATION_TABLE_BASED_ON_EQUIPMENT_RESOURCE_FILTER = gql`
    mutation repopulateAssociationTableBasedOnEquipmentResourceFilter {
        vacKeyGroupService_repopulateAssociationTableBasedOnEquipmentResourceFilter
    }
`;

export const GENERATE_VAC_KEYS_PER_EQUIPMENT = gql`
    query generateVacKeysPerEquipment {
        vacKeyGroupService_generateVacKeysPerEquipment
    }
`;

export const TEMP_GENERATE_AND_SEND = gql`
    mutation tempGenerateAndSend {
        vacKeyGroupService_tempGenerateAndSend
    }
`;
